import { StyleRules, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRules = {
  container: {
    flexGrow: 1
  }
};

const BaseContainer: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
);

export const TextContainer = withStyles(styles)(BaseContainer);
